import * as Yup from 'yup'
import catchApiFailure from '../catch-api-error'
import ApiFactory, { ApiTypes } from '../../index'
import configBuilder from '../config-builder'
import qs from 'qs'

const api = ApiFactory.getApi(ApiTypes.member)

const RequestSchema = Yup.object().shape({
  pieceId: Yup.string().required(),
  usertype: Yup.string().optional(),
})

type Request = Yup.InferType<typeof RequestSchema>

export const isValid = async (params: Request) => RequestSchema.isValid(params)
export const validate = async (params: Request) => await RequestSchema.validate(params)

export const url = ({ pieceId, usertype }: Request) => {
  const queryParams = {
    populate: {
      authors: true,
      tags: true,
      perms: true,
      metadata: {
        populate: {
          coverImage: true,
          thumbnailImage: true,
        },
      },
      body: {
        populate: '*',
        on: {
          'piece.image': {
            populate: {
              imageFile: true,
            },
          },
          'piece.slider': {
            populate: {
              slides: {
                populate: {
                  image: true,
                },
              },
            },
          },
          'piece.podcast': {
            populate: {
              timelycasts: {
                populate: {
                  timelycast: {
                    populate: ['file', 'thumbnailImage', 'tags'],
                  },
                },
              },
            },
          },
          'piece.callout-card-group': {
            populate: {
              calloutCard: true,
            },
          },
          'video.video': {
            populate: {
              video: {
                populate: {
                  file: true,
                  subtitles: {
                    populate: {
                      vttFile: true,
                    },
                  },
                },
              },
            },
          },
          'piece.section-paragraph': true,
          'piece.pull-quote': true,
          'piece.external-video': {
            populate: {
              externalVideo: true,
            },
          },
        },
      },
      related: {
        populate: {
          piece: {
            populate: {
              metadata: {
                populate: {
                  coverImage: true,
                  thumbnailImage: true,
                },
              },
            },
          },
          journey: {
            populate: {
              metadata: {
                populate: {
                  coverImage: true,
                  thumbnailImage: true,
                },
              },
            },
          },
        },
      },
      localizations: true,
    },
    ...(usertype && {
      filters: {
        perms: {
          name: {
            $in: [usertype],
          },
        },
      },
    }),
  }

  return `/v1/strapi/api/pieces/${pieceId}?${qs.stringify(queryParams, { encode: false })}`
}

// TODO: remove once configBuilder is typed
//@ts-ignore
export const execute = async (params: Request) => api.get(url(params), configBuilder(params)).catch(catchApiFailure)
